import { useEffect, useRef } from 'react';

/**
 * @typedef UseEffectPlusParams
 * @property {boolean} isFirstMount
 */

/**
 * Extended version of `useEffect()`, which provides additional information in
 *  the effect callback's parameters.
 * @param {(params: UseEffectPlusParams) => (void | () => void)} effect
 * @param {any[]} deps
 */
export default function useEffectPlus(effect, deps) {
    const extrasRef = useRef({
        isFirstMount: true,
    });

    useEffect(() => {
        const cleanup = effect({ ...extrasRef.current });

        extrasRef.current.isFirstMount = false;

        return cleanup;
    }, deps);
}